import React from "react";
import styled from "styled-components/macro";

interface H1Props {}

const H1: React.FC<H1Props> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.h1`
  position: absolute;
  transform: translateX(-10000px);
`;

export default H1;
